import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import type {
  GraphBreadcrumbType,
  PathLookupModeBreadcrumb,
} from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { loadEmptyGraph } from 'components/Graph/commands/loadEmptyGraph';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { PathlookupIcon } from 'components/Graph/icons/PathlookupIcon';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';
import { useConfirmDialog } from 'utils/hooks/useConfirmDialog';

const removedByBreadcrumbClick: GraphBreadcrumbType[] = [
  'pathLookupInstance',
  'compareMode',
  'intentCheck',
];

export const getPathLookupModeBreadcrumbText = (
  _breadcrumb: PathLookupModeBreadcrumb,
  msg: AppTranslations,
): string => msg.canvasGraph.breadcrumbs.pathLookupMode.label;

export const PathLookupModeBreadcrumbItem: FC<
  GraphBreadcrumbProps<PathLookupModeBreadcrumb>
> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const confirmDialog = useConfirmDialog({
    name: 'PATH_LOOKUP_MODE_BREADCRUMB',
  });

  return (
    <>
      <confirmDialog.DialogComponent
        msg={msg.canvasGraph.breadcrumbs.confirmMainBreadcrumbClick}
        onClickConfirm={() => {
          ctxProps.dispatch(loadEmptyGraph);
          ctxProps.dispatch(showSidePanel, { pathLookupTabId: 'dataInput' });
        }}
        btnConfirmVariant='primary'
        btnConfirmAccent='positive'
        btnCancelVariant='secondary'
        btnCancelAccent='positive'
      />
      <GraphBreadcrumbContainer
        className='hover__container'
        containerStyle='primary'
        onClick={() => {
          confirmDialog.toggleConfirmDialog();
        }}
        onIndicateRemoveOthers={props.onIndicateRemoveOthers}
        removedByBreadcrumbClick={removedByBreadcrumbClick}
      >
        <PathlookupIcon
          title={null}
          variant='dark'
          className='mr-lgu-3 -ml-lgu-2 hover__item--nonhover'
        />
        <PathlookupIcon
          title={null}
          variant='coloredLight'
          className='mr-lgu-3 -ml-lgu-2 hover__item--hover'
        />
        {getPathLookupModeBreadcrumbText(props.content, msg)}
      </GraphBreadcrumbContainer>
    </>
  );
};
